"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var d3 = _interopRequireWildcard(require("d3"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-unused-vars, no-use-before-define */

const zoomable = _ref => {
  let {
    el,
    duration
  } = _ref;
  const zoomed = (event, d) => {
    svg.attr('transform', event.transform);
  };
  const zoom = d3.zoom().on('zoom', zoomed);
  const resetZoom = () => {
    svg.transition().duration(duration).call(zoom.transform, d3.zoomIdentity);
  };
  const svg = d3.select(el).append('svg').attr('id', 'svg-file-container').attr('width', '100%').attr('height', '100%').call(zoom).on('dblclick.zoom', resetZoom).append('g');
  return svg;
};
var _default = exports.default = zoomable;